import styled from 'styled-components';
import Text from '../../../components/Text';

export const CardContainer = styled.div`
  margin: 0 auto;
  background-color: #3c99ff;
  width: 100%;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  transition: 0.3s;
  padding: 30px 30px;
`;

export const PointsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
`;

export const PointsText = styled(Text)`
  text-shadow: 0px 0px 15px #d8ebff;
`;
